module.exports = __webpack_public_path__ + "img/icon-very-satisfied.e89263a.svg";